import React from "react";
import Icon from "./Icon";

/**
 * Custom confirm dialog to replace ugly window.confirm()
 */
function ConfirmModal({ show, title, message, confirmText, cancelText, danger, onConfirm, onCancel }) {
  if (!show) return null;

  return (
    <div className="modal-overlay confirm-overlay" onClick={onCancel}>
      <div className="modal-box confirm-modal" onClick={e => e.stopPropagation()}>
        <div className="confirm-icon">
          {danger ? (
            <Icon name="warning" style={{ color: "#ea4335", fontSize: 32 }} />
          ) : (
            <Icon name="question" style={{ color: "#4285f4", fontSize: 32 }} />
          )}
        </div>
        <h3 className="confirm-title">{title || "Confirm"}</h3>
        <p className="confirm-message">{message || "Are you sure?"}</p>
        <div className="confirm-actions">
          <button className="modal-btn cancel" onClick={onCancel}>
            {cancelText || "Cancel"}
          </button>
          <button
            className={`modal-btn ${danger ? "danger" : "create"}`}
            onClick={onConfirm}
          >
            {confirmText || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
